// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { AllCustomerReferrals } from "../flow/types";

export default function(
  state: AllCustomerReferrals = initialState.referrals,
  action: any
): AllCustomerReferrals {
  switch (action.type) {
      case ActionTypes.GET_CUSTOMER_REFERRALS + ActionTypes.FULFILLED:
        return action.payload.data;
    default:
      return state;
  }
}
